// Q12 S5 — pure helpers consumed by NotificationsDrawer.
// buildUrl resolves a NotificationLink into a relative path (or absolute
// URL for "external"); shouldOpenInNewTab gates the new-tab branch.
//
// Mirrors the routing rules in docs/specs/notification-deep-link-payload.md
// §URL construction. Per Q12 D5 + payload spec: carer + invoice
// notifications use type: "page" with bare list paths (/carers, /billing)
// in v1; reserved enum members upgrade to type: "carer" / "invoice" when
// detail pages ship (TASK-50/51).

import type { NotificationLink } from "@hcm/core";

// Dispatch table for ID-bearing link types — keeps buildUrl flat
// and under the complexity cap.
const ID_PATHS: Record<"sr" | "patient" | "carer" | "invoice", (id: string, view?: string) => string> = {
  sr:      (id, view) => view ? `/sr/${id}/${view}` : `/sr/${id}`,
  patient: (id) => `/patients/${id}`,
  carer:   (id) => `/carers/${id}`,
  invoice: (id) => `/billing/${id}`,
};

export function buildUrl(link: NotificationLink | undefined | null): string | null {
  if (!link) return null;
  if (link.type === "page" || link.type === "external") return link.target_path ?? null;
  if (!link.target_id) return null;
  return ID_PATHS[link.type](link.target_id, link.view);
}

export function shouldOpenInNewTab(link: NotificationLink | undefined | null): boolean {
  return link?.type === "external";
}
